






















import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { DropdownLight } from '../../../../shared/dropdown-light';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { currentUserKey } from '../../../../shared/msw-constants';
import { localStorageKeeperService } from '@/shared/auth-service';
import * as decode from 'jwt-decode';
const cssPrefix = 'tenant-edit';

@Component({
  components: {
    DropdownLight,
  },
})
export default class TenantEdit extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  list : any;
  @Prop({ required : true })
  index : any;
  @Prop({ required : true })
  showTenantTransf: any;
  displayNone : boolean = false;
  getEditOptions : SelectOption[] = [];
  value: string = 'Edit';
  created() {
    this.setEditTenetOptions();
    this.displayNone = this.getEditOptions.length === 0 ? true : false;
  }

  editOrDeleteToggleFunction(e : any) {
    console.warn(e);
    const obj = {
      index : e,
      list : this.list,
    };
    this.$emit('option-clicked' , obj);
  }
  showEdit(e : any) {
    console.warn(e);
  }
  visibility(val : any) {
    this.$emit('dropdown-visible', val);
    this.$emit('index-val', this.index);
  }

  setEditTenetOptions() {
    if (this.list.isDefaultGroup.toLowerCase() !== 'true' && this.list.renameLink.toLowerCase() === 'true') {
      this.getEditOptions.push({ id: '1', label: (this.$t('common.edit')
      .toString()), value: 'Edit' });
    }
    if ((this.list.isDefaultGroup.toLowerCase() !== 'true') && this.list.deleteLink.toLowerCase() === 'true') {
      this.getEditOptions.push({ id: '2', label: (this.$t('common.delete')
      .toString()), value: 'Delete' });
    }
    if (this.$store.getters.isLargeCustomer) {
      const currentUser = JSON.parse(
        localStorageKeeperService.retrieve(currentUserKey),
      );
      let isShowTenentInfo: boolean = false;
      if (currentUser &&
         currentUser.roles) {
        if (Array.isArray(currentUser.roles)) {
          isShowTenentInfo = currentUser.roles.length > 0 &&
            currentUser.roles.includes('MSSPPAYGO') || currentUser.roles.includes('MASTERMSSPBETA') || false;
        } else if (typeof currentUser.roles === 'string') {
          isShowTenentInfo = currentUser.roles &&
            currentUser.roles.indexOf('MSSPPAYGO') > -1 || currentUser.roles.indexOf('MASTERMSSPBETA') > -1 || false;
        } else {
          isShowTenentInfo = false;
        }
        if (isShowTenentInfo) {
          this.getEditOptions.push({ id: '3', label: (this.$t('products.tenantInfo')
          .toString()), value: 'TenantInfo' });
        }
      }
    } else {
      if (this.list.showTenantInfo) {
        if (this.list.showTenantInfo.toLowerCase() === 'true') {
          this.getEditOptions.push({ id: '3', label: (this.$t('products.tenantInfo')
          .toString()), value: 'TenantInfo' });
        }
      }
    }
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    if (this.list.isDefaultGroup.toLowerCase() !== 'true' && token?.orgbased === 'YES' && this.showTenantTransf) {
      this.getEditOptions.push({ id: '4', label: (this.$t('products.transferTenant')
      .toString()), value: 'TransferTenant' });
    }
  }

}
